module.exports = __webpack_public_path__ + "img/antiHipThrustText2.2f6213d4.png";